import {
  Body,
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Separator,
} from '@e2n/ui/v2';
import type { RotationsplanVorlage } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanVorlagen/useRotationsplanVorlagen';
import type { Dauer } from '@/domain/mitarbeiter/features/rotationsplan/utils/getGesamtdauer';
import { Mitarbeiter_RotationsplanVorlageDauerEinheit } from '@/gql/graphql';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

export function StationenPopover({
  vorlage,
}: {
  vorlage: RotationsplanVorlage;
}) {
  const { t } = useTranslation();

  const formatDauer = ({ dauer, dauerEinheit }: Dauer) =>
    t(
      `domain.mitarbeiter.rotationsplan.vorlagen.details.dauer.${dauerEinheit}`,
      {
        count: dauer,
      },
    );

  const gesamtdauerInMonaten = formatDauer({
    dauer: vorlage.gesamtdauer.monate,
    dauerEinheit: Mitarbeiter_RotationsplanVorlageDauerEinheit.Monate,
  });
  const gesamtdauer = vorlage.gesamtdauer.ungefaehr
    ? t('domain.mitarbeiter.rotationsplan.vorlagen.gesamtdauerUngefaehr', {
        dauer: gesamtdauerInMonaten,
      })
    : gesamtdauerInMonaten;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          className="relative z-10 min-w-0 shrink data-[state=open]:bg-neutrals-v2-200"
          disabled={vorlage.stationen.length < 1}
          type="button"
          variant="outline">
          <FontAwesomeIcon icon={faCalendarRange} />
          <span className="truncate">{gesamtdauer}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="gap-4 md:w-62 md:py-4">
        <Body className="px-4 text-center md:text-left" weight="semibold">
          {t('domain.mitarbeiter.rotationsplan.vorlagen.stationenUndDauer')}
        </Body>
        <ul className="flex min-h-0 flex-col gap-3 overflow-y-auto md:gap-2">
          {vorlage.stationen.map((station, index) => (
            <li key={station.id} className="flex flex-col gap-3 md:gap-2">
              {index > 0 && <Separator />}
              <div className="flex items-center justify-between gap-2 px-4">
                <div className="flex min-w-0 items-center gap-2">
                  {station.arbeitsbereich && (
                    <FontAwesomeIcon
                      icon={faCircle}
                      color={station.arbeitsbereich.color}
                      className="size-2.5"
                    />
                  )}
                  <Body className="truncate">
                    {station.arbeitsbereich?.name ??
                      t(
                        'domain.mitarbeiter.rotationsplan.vorlagen.details.zeitraumOhneStation',
                      )}
                  </Body>
                </div>
                <Body className="shrink-0 whitespace-nowrap">
                  {formatDauer(station)}
                </Body>
              </div>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
